import { Routes, Route } from "react-router-dom";

import PBuyer from "./PBuyer";
import PSeller from "./PSeller";
import PGallery from "./gallery/PGallery";

export default function App() {
  return (
    <Routes>
      {/* Seller Routes */}
      <Route path="/seller/*" element={<PSeller />} />

      {/* Gallery Routes */}
      <Route path="/gallery/*" element={<PGallery />} />

      {/* Buyer Routes */}
      <Route path="/*" element={<PBuyer />} />
    </Routes>
  );
}